import { DomUtils } from './utils';

class Swipers {
    constructor(Swiper) {
        if (typeof Swiper == 'undefined') {
            return;
        }

        this.viewportWidth = DomUtils.getViewportWidth();
        this.vw = this.viewportWidth / 100;
        this.createSwiperProjectImages();
        this.createSwiperCardItem();
        this.createSwiperCards();
    }

    createSwiperProjectImages() {
        const projectCards = document.querySelectorAll('.card-item-project');
        if (!projectCards.length) {
            return;
        }

        projectCards.forEach((projectCard) => {
            const projectImagesSwiper = projectCard.querySelector('.swiper-project-images');
            const projectImagesPagination = projectCard.querySelector('.swiper-project-images-pagination');
            const projectImagesNavigationNext = projectCard.querySelector('.swiper-project-button-next');
            const projectImagesNavigationPrev = projectCard.querySelector('.swiper-project-button-prev');
            if (!projectImagesSwiper) {
                return;
            }

            new Swiper(projectImagesSwiper, {
                slidesPerView: 1,
                spaceBetween: 10,
                grabCursor: true,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                },
                navigation: {
                    nextEl: projectImagesNavigationNext,
                    prevEl: projectImagesNavigationPrev
                },
                pagination: {
                    el: projectImagesPagination,
                    type: 'bullets',
                    clickable: true
                }
            });
        });
    }

    createSwiperCardItem() {
        const cardItemSwiper = document.querySelectorAll('.card-item-swiper');
        if (!cardItemSwiper.length) {
            return;
        }

        cardItemSwiper.forEach((swiper) => {
            const perentBlockElement = swiper.closest('.block');
            const swiperNavigationNext = perentBlockElement.querySelector('.swiper-button-next');
            const swiperNavigationPrev = perentBlockElement.querySelector('.swiper-button-prev');

            let desktopSlidesPerView = 3;
            if (swiper.querySelectorAll('.swiper-slide').length > desktopSlidesPerView) {
                desktopSlidesPerView = 2.8;
            }
            new Swiper(swiper, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                navigation: {
                    nextEl: swiperNavigationNext,
                    prevEl: swiperNavigationPrev
                },
                breakpoints: {
                    600: {
                        slidesPerView: 1.75
                    },
                    1020: {
                        slidesPerView: 2.5
                    },
                    1200: {
                        slidesPerView: desktopSlidesPerView
                    }
                }
            });
        });
    }

    createSwiperCards() {
        const cardsGrids = document.querySelectorAll('.cards-grid');
        if (!cardsGrids.length) {
            return;
        }

        cardsGrids.forEach((cardsGrid) => {
            const cardCount = cardsGrid.querySelectorAll('.swiper-slide').length;
            const wrapperElement = cardsGrid.closest('.cards-grid-wrapper');
            const swiperNavigationNext = wrapperElement ? wrapperElement.querySelector('.swiper-button-next') : null;
            const swiperNavigationPrev = wrapperElement ? wrapperElement.querySelector('.swiper-button-prev') : null;

            if (this.viewportWidth > 800 && cardCount <= 4) {
                if (swiperNavigationNext) {
                    swiperNavigationNext.classList.add('swiper-button-lock');
                }
                if (swiperNavigationPrev) {
                    swiperNavigationPrev.classList.add('swiper-button-lock');
                }
                return;
            }

            // Check on parent div .block if it has class .theme-grey
            const perentBlockElement = cardsGrid.closest('.block');
            const isThemeGrey = perentBlockElement.classList.contains('theme-grey');

            let slidesPerView = 1.08;
            if (isThemeGrey) {
                slidesPerView = 1.3;
            }

            new Swiper(cardsGrid, {
                offsetBefore: 16,
                offsetAfter: 16,

                slidesPerView: slidesPerView,
                spaceBetween: 20,
                navigation: {
                    nextEl: swiperNavigationNext,
                    prevEl: swiperNavigationPrev
                },
                breakpoints: {
                    800: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    }
                }
            });
        });
    }
}
new Swipers(Swiper);
